import 'focus-visible';
import 'focus-options-polyfill';
import T from 'prop-types';
import { createGlobalStyle } from 'styled-components';
import { purple4 } from '../../styles/colors';
import { fontFace } from '../../styles/fontFace';
import { normalize } from '../../styles/normalize';
import { fontFamilyBody } from '../../styles/typography';
import { themeGet } from '../../styles/styled-system';
const GlobalStyle = /*#__PURE__*/createGlobalStyle`
  ${normalize}
  ${fontFace}

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  html {
    box-sizing: border-box;
    background-color: ${themeGet('global.backgroundColor', purple4)};
    font-size: 100% !important;
  }

  html, body ${props => props.appRootSelector ? `, ${props.appRootSelector}` : undefined} {
    width: 100%;
    min-height: 100vh;
  }

  body {
    overflow-y: scroll;
    font-family: ${fontFamilyBody};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  table {
    border-collapse: collapse;
  }

  ul,
  ol {
    list-style: none;
  }

  ul,
  ol,
  li,
  dl,
  dd {
    margin: 0;
    padding: 0;
  }

  /* global style for focus-visible */
  .js-focus-visible :focus:not(.focus-visible) {
    outline: none;
  }
`;
GlobalStyle.propTypes = {
  appRootSelector: T.string
};
export { GlobalStyle };